import { memo, useCallback } from 'react';
import { IMAGE_FORMAT_ICONS } from '../UploadedImages.content';
import { UploadedImageProps } from './UploadedImage.types';
import Box from '../../../Box/Box';
import Text from '../../../Text/Text';
import Icon from '../../../Icon/Icon';
import PressableIcon from '../../../PressableIcon/PressableIcon';

function UploadedImage({
  type,
  index,
  fileName,
  onDelete,
}: UploadedImageProps) {
  const handleDelete = useCallback(() => {
    onDelete(index);
  }, [index, onDelete]);

  return (
    <Box width={75} gap="space-100">
      <Box
        alignSelf="center"
        width="space-1200"
        height="space-1200"
        backgroundColor="iconTertiary"
        borderRadius="radius-200"
        padding="space-200"
      >
        {type && (
          <Icon
            name={IMAGE_FORMAT_ICONS[type]}
            gradient="accentBackground"
            width="100%"
            height="100%"
          />
        )}
      </Box>
      <Box width="100%" flexDirection="row" alignItems="center">
        <Text
          variant="body-m"
          color="darkSurfacePrimary"
          numberOfLines={1}
          flex={1}
        >
          {fileName}
        </Text>
        <PressableIcon
          name="close"
          width="space-600"
          height="space-600"
          color="darkSurfaceError"
          onPress={handleDelete}
        />
      </Box>
    </Box>
  );
}

export default memo(UploadedImage);
